import { Badge, Button } from 'antd';
import classNames from 'classnames';
import React, { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import type { ChannelManager } from 'app/typings/channelManagers';

import { ChannelManagerTag } from '../../../ChannelManagerTag/ChannelManagerTag';
import type { InventoryActionsProps } from '../InventoryActions/InventoryActions';
import { InventoryActions } from '../InventoryActions/InventoryActions';
import type { InventoryToggleProps } from '../InventoryToggle/InventoryToggle';
import { InventoryToggle } from '../InventoryToggle/InventoryToggle';

import styles from './InventoryControls.module.scss';

export type AutoInventoryConfig = {
  onClick: () => void;
  icon?: React.ReactNode;
  label?: string;
  disabled?: boolean;
};

export type InventoryControlsProps = {
  toggle?: InventoryToggleProps;
  autoInventory?: AutoInventoryConfig;
  actions: InventoryActionsProps;
  className?: string;
  channelManager?: ChannelManager;
};

export const InventoryControls: React.FC<InventoryControlsProps> = ({
  toggle,
  autoInventory,
  actions,
  channelManager,
  className = '',
}) => {
  const { hotelInfo } = useContext(HotelContext);

  return (
    <div className={classNames(styles.inventoryControls, className)}>
      {toggle && <InventoryToggle {...toggle} />}
      {autoInventory && (
        <div className={styles.autoInventoryControl}>
          <Button
            icon={
              hotelInfo?.stockScrapperEnabled ? (
                <Badge color="#003A8C" />
              ) : (
                autoInventory.icon
              )
            }
            onClick={autoInventory.onClick}
            disabled={autoInventory.disabled}
            className={classNames({
              [styles.activeAutoInventory]: hotelInfo?.stockScrapperEnabled,
            })}
          >
            {hotelInfo?.stockScrapperEnabled
              ? 'Auto inventory'
              : (autoInventory.label ?? 'Automate inventory')}
          </Button>
          {autoInventory.disabled && (
            <span className={styles.autoInventoryHint}>
              Create a room first to enable inventory automation.
            </span>
          )}
        </div>
      )}
      {channelManager && (
        <ChannelManagerTag
          variant={channelManager}
          supplierId={hotelInfo?.supplierId}
        />
      )}
      <InventoryActions {...actions} />
    </div>
  );
};
